import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import camera from '../assets/camera.png';
import analyze from '../assets/anal.png';
import recipe from '../assets/recipe.png';

const MockupContainer = styled(motion.div)`
  position: relative;
  width: 300px;
  height: 600px;
  margin: 0 auto;
  z-index: 1;
`;

const PhoneFrame = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 45px;
  background: #0A0A0A;
  box-shadow: 0 25px 60px -12px rgba(0, 0, 0, 0.5),
              0 10px 20px -5px rgba(0, 0, 0, 0.4),
              inset 0 0 0 1px rgba(100, 100, 100, 0.2),
              -4px 0 5px -3px rgba(0, 0, 0, 0.7),
              4px 0 5px -3px rgba(0, 0, 0, 0.7);
  overflow: hidden;
  border: 10px solid #222;
  display: flex;
  flex-direction: column;
  
   transform: scale(0.96) !important; 

 `;

const PhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  background: #0F0F0F;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  
  border-radius: 35px;
`;

const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
`;

const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
`;

const DynamicIsland = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 34px;
  background: #000000;
  border-radius: 20px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05);
  
  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background: #333;
    border-radius: 50%;
    right: 15px;
  }
  
  &::before {
    content: '';
    position: absolute;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 2px;
    left: 15px;
  }
`;

const StatusBar = styled.div`
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
  align-items: center;
  z-index: 9;
  font-size: 14px;
  font-weight: 600;
  color: white;
`;

const TimeDisplay = styled.div`
  text-align: left;
`;

const StatusIcons = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const BatteryIcon = styled.div`
  width: 25px;
  height: 12px;
  border: 1.5px solid white;
  border-radius: 3px;
  padding: 1px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 18px;
    background-color: white;
    margin: 1px;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: -4px;
    top: 3px;
    width: 2px;
    height: 4px;
    border-radius: 0 2px 2px 0;
    background-color: white;
  }
`;

const SignalIcon = styled.div`
  display: flex;
  align-items: flex-end;
  height: 12px;
  gap: 1px;
  
  span {
    width: 3px;
    background-color: white;
    border-radius: 1px 1px 0 0;
    
    &:nth-child(1) { height: 5px; }
    &:nth-child(2) { height: 7px; }
    &:nth-child(3) { height: 9px; }
    &:nth-child(4) { height: 11px; }
  }
`;

const StepIndicator = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
  z-index: 10;
`;

const StepDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.3)'};
  transition: all 0.3s ease;
`;

const ScreenContent = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
`;

const StepNumber = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6C2FF2, #8A2BE2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(108, 47, 242, 0.4);
  overflow: hidden;
`;

const StepTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  color: white;

  margin-bottom: 8px;
  text-align: center;
`;

const StepDescription = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  line-height: 1.4;
`;

const NextButton = styled.div`
  position: absolute;
  bottom: 70px;
  right: 20px;
  color: #B69DFF;
  font-size: 16px;
  font-weight: 600;
  z-index: 10;
  cursor: pointer;
`;

const StepsContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  gap: 16px;
  margin-top: 20px;
`;

const StepItem = styled(motion.div)`
  display: flex;
  align-items: center;
  width: 80%;
  padding: 12px 16px;
  border-radius: 18px;
  background: transparent;
`;

const StepText = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  flex: 1;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
`;

const StepIconContainer = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-left: auto;
  // background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: white;
`;

const AnimatedOverlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
  z-index: 5;
  cursor: pointer;
`;

const OverlayTitle = styled(motion.h3)`
  font-size: 24px;
  font-weight: 700;
  color: white;
  text-align: center;
  margin-bottom: 16px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.6);
  font-family: "Black Han Sans", sans-serif;
`;

const OverlaySubtitle = styled(motion.p)`
  font-size: 18px;
  color: #DCB9FF;
  text-align: center;
  max-width: 85%;
  line-height: 1.5;
  font-family: "Black Han Sans", sans-serif;
  font-weight: 400;
`;

const TapHint = styled(motion.div)`
  margin-top: 40px;
  color: white;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 20px;
  opacity: 0.8;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
`;

const FullscreenPhoneMockup = ({ videoSrc }) => {
  const videoRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);
  
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(e => console.error('Ошибка воспроизведения видео:', e));
    }
  }, []);

  const toggleOverlay = () => {
    setShowOverlay(!showOverlay);
  };

  const steps = [
    { number: 1, text: "Snap a pic of your fridge", img: camera },
    { number: 2, text: "We look at what’s inside", img: analyze },
    { number: 3, text: "Boom! Yummy meals for you", img: recipe }
  ];

  return (
    <MockupContainer
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <PhoneFrame
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <DynamicIsland />
        
        <PhoneScreen>
          <StatusBar>
            <TimeDisplay>9:41</TimeDisplay>
            <StatusIcons>
              <SignalIcon>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </SignalIcon>
              <BatteryIcon />
            </StatusIcons>
          </StatusBar>
          
          <VideoContainer>
            <VideoElement 
              ref={videoRef}
              src={videoSrc} 
              loop 
              muted 
              playsInline
            />
          </VideoContainer>
          
          <AnimatePresence>
            {showOverlay && (
              <AnimatedOverlay
                initial={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.4 }}
                onClick={toggleOverlay}
              >
                <StepsContainer>
                  {steps.map((step, index) => (
                    <StepItem
                      key={step.number}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.5 + index * 0.15 }}
                    >
                      <StepNumber>
                        <img src={step.img} alt={`step ${step.number}`} style={{width: '20px', height: '20px'}}/>
                      </StepNumber>
                      <StepText>{step.text}</StepText>
                      <StepIconContainer>
                      </StepIconContainer>
                    </StepItem>
                  ))}
                </StepsContainer>
                
                <TapHint
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 1.2 }}
                >
                  Tap to view
                </TapHint>
              </AnimatedOverlay>
            )}
          </AnimatePresence>
          
          {!showOverlay && (
            <motion.div
              style={{ 
                position: 'absolute', 
                bottom: '20px', 
                right: '20px',
                zIndex: 10,
                background: 'rgba(108, 47, 242, 0.8)',
                borderRadius: '50%',
                padding: '10px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              onClick={toggleOverlay}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M12 6v12M6 12h12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </motion.div>
          )}
        </PhoneScreen>
      </PhoneFrame>
    </MockupContainer>
  );
};

export default FullscreenPhoneMockup; 